import { z } from "zod";

import { constantsData } from "@/data";

export const userPasswordFormSchema = z.object({
    id: z.string().optional(),
    password: z.string().min(
        6,
        { message: constantsData.msgs.minPassword },
    ),
});
